import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import {
	INLINE_LUMINA_STATUS_PREFIX,
	isInlineLuminaStatus,
} from '@atlassian/conversation-assistant-content-transformer/utils/inline-lumina';

import { InlineCitation } from '../../../ai-answer-dialog/ai-answer-body/ai-answer-result/rendered/inline-citation/inline-citation';
import { StatusCitation } from '../../../ai-answer-dialog/ai-answer-body/ai-answer-result/rendered/status-citation';
import { LUMINA_CONTENT_PREFIX } from '../../../ai-answer-dialog/utils/fetchAIAnswer';
import { SAINFeatureControl } from '../../../common/utils/sain-feature-control';

const LUMINA_START_TAG = '<lumina>';
const LUMINA_END_TAG = '</lumina>';

export type StatusComponentProps = {
	localId: string;
	text: string;
	color?: string;
};

const LuminaLayout = React.lazy(() =>
	import(
		/* webpackChunkName: "@atlassian-internal_lumina-layout" */
		'@atlassian/lumina'
	).then((mod) => ({ default: mod.LuminaLayout })),
);

export const renderStatusComponent = (
	props: StatusComponentProps,
	markdownData: Record<string, string> | undefined,
	appContext: { orgId: string; cloudId: string; sourceProduct: string },
	userId: string,
): React.JSX.Element => {
	if (isInlineLuminaStatus(props.localId)) {
		// retrieve idx of status node created by extension
		const luminaIdx = parseInt(props.text.replace(INLINE_LUMINA_STATUS_PREFIX, ''), 10);
		// map idx to content from markdownData created during streaming
		const luminaContent = markdownData?.[`${LUMINA_CONTENT_PREFIX}${luminaIdx}`] ?? '';

		if (luminaContent) {
			return (
				<LuminaLayout
					luminaTagResponse={`${LUMINA_START_TAG}${luminaContent}${LUMINA_END_TAG}`}
					source="luminaSAIN"
					smartLinkRenderer="embed"
					cloudId={appContext.cloudId}
					orgId={appContext.orgId}
					requestingUserId={userId}
					sourceProduct={appContext.sourceProduct}
				/>
			);
		}
	}

	if (fg('kd_team_26_sain_inline_citations_update') || SAINFeatureControl.isSAINUXUpliftEnabled()) {
		return <InlineCitation {...props} />;
	}

	return <StatusCitation {...props} />;
};
